export const Link = () => (
  <path
    d='M16 8H12.8V9.6H16C17.32 9.6 18.4 10.68 18.4 12C18.4 13.32 17.32 14.4 16 14.4H12.8V16H16C18.208 16 20 14.208 20 12C20 9.792 18.208 8 16 8ZM11.2 14.4H8C6.68 14.4 5.6 13.32 5.6 12C5.6 10.68 6.68 9.6 8 9.6H11.2V8H8C5.792 8 4 9.792 4 12C4 14.208 5.792 16 8 16H11.2V14.4ZM8.8 11.2H15.2V12.8H8.8V11.2Z'
    fill='currentColor'
  />
)
